module.exports = __webpack_public_path__ + "media/images/icon_message01_on_18-14-f14ed84bf262b2792951691156473ea0.png";